// @flow

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  url: string,
  adversaire: string,
  score_france: number,
  score_adversaire: number,
  logo_adversaire: string, 
  logo_france: string,
  date_rencontre: string,
  reception: boolean,
  journee?: number|boolean,
  competition?: {
    name? : string,
    id? : number
  }
};

class MatchResult extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    adversaire: '',
    score_france: 0,
    score_adversaire: 0,
    logo_adversaire: '', 
    logo_france: '',
    date_rencontre: '',
    journee: false,
    reception: false,
    competition: false,
  };

  render() {
    const { 
      url, 
      adversaire, 
      score_france, 
      score_adversaire, 
      reception, 
      logo_adversaire, 
      logo_france,
      date_rencontre,
      journee,
      competition
    } = this.props;

    let texte_journee = '';
    if (journee) {
      texte_journee = 'Journée ' + journee.toString() + '  —  ';
    }

    return (
      <div>
        <p className="ft-h6 ft-up">{competition && competition.name ? competition.name : ''}</p>
        <p className="ft-h6 ft-up ft-center">{texte_journee}{date_rencontre}</p>
        <Link
          to={url}
          className="match"
          title="Voir les informations du match">
          <div className="match__club">
            <p className={reception ? (score_france > score_adversaire ? 'ft-700':'') : (score_adversaire > score_france ? 'ft-700':'')}>
            { reception ? 'France' : adversaire } <img src={reception ? logo_france : logo_adversaire} alt="" width="24" height="24" /></p>
          </div>
          <div className="match__info">
            <p className="match__score">
              <span className={reception ? (score_france > score_adversaire ? 'ft-700':'') : (score_adversaire > score_france ? 'ft-700':'')}>{reception ? score_france : score_adversaire}</span>
              <span className="match__colon">:</span>
              <span className={reception ? (score_adversaire > score_france  ? 'ft-700':'') : (score_france > score_adversaire  ? 'ft-700':'')}>{reception ? score_adversaire : score_france}</span>
            </p>
          </div>
          <div className="match__club">
            <p className={reception ? (score_adversaire > score_france  ? 'ft-700':'') : (score_france > score_adversaire  ? 'ft-700':'')}>
              <img src={reception ? logo_adversaire : logo_france} alt="" width="24" height="24" />{reception ? adversaire : 'France'}
            </p>
          </div>
        </Link>
      </div>
    );
  }
}

export default MatchResult;
